export interface TaskTypeOption {
  name: string;
  value: string;
}

/** Canonical task types — shared by form, list filter, and labels. */
export const TASK_TYPE_OPTIONS: TaskTypeOption[] = [
  { name: 'General', value: 'GENERAL' },
  { name: 'Inspection', value: 'INSPECTION' },
  { name: 'Meeting', value: 'MEETINGS' },
  { name: 'Contact', value: 'CONTACT' },
];

export const TASK_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  TASK_TYPE_OPTIONS.map((o) => [o.value, o.name])
);

export function taskTypeDisplayLabel(type?: string | null): string {
  if (!type) return '—';
  return TASK_TYPE_LABELS[String(type).toUpperCase()] || String(type);
}
